import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import { toast } from 'react-toastify';
import ModalFile from '../../Partials/ModalFileFichas';
import cookie from 'react-cookies';
import {API_URL} from '../../../constants';
import { DropDownList, DropDownListChild } from '../../Elements/Select/dropdown';
import {showModalPageClass, hideLoader, hideModalPageClass, setTextInputLongitud, generateSlugAutomatico, setDataForm} from '../../../functions';
import axios from 'axios';
import Error from '../../Error/error';
import {BASE_URL_PRODUCTOS} from '../../../constants';
import {convertFromHTML, EditorState, ContentState} from 'draft-js';
import {stateToHTML} from 'draft-js-export-html';
import {Editor} from 'react-draft-wysiwyg';

import CKEditor from 'ckeditor4-react';
import { ckeditorconfig } from '../../functions/functions';
import { cacheConfig, generateLabel, getFrontPageUrl } from '../../../utils/functions';

export default class FichaProductoEditar extends Component {
    constructor(props) {
        super(props);

        this.state = {
            fichaProducto: {
                sDescripcion:       "",
                presentacion:       "",
                origen:             "",
                especie:            "",
                zonaProduccion:     "",
                normas:             "",
                usoAplicaciones:    "",
                Fpro_MostrarModuloEventos: false,
            },
            titulos: [],
            Validacion: {
                nombreProducto: {
                    Error: false,
                    RequeridoError: "El campo Nombre es requerido."
                },
                fpro_Slug: {
                    Error: false,
                    RequeridoError: "El campo Slug es requerido."
                },
                nombreComercial: {
                    Error: false,
                    RequeridoError: "El campo Nombre Comercial es requerido."
                },
                nSectorCodigo: {
                    Error: false,
                    RequeridoError: "El campo Sector es requerido."
                },
                imagenProducto: {
                    Error: false,
                    RequeridoError: "El campo Imagen del producto es requerido."
                }
            },
            key: "0",
            guardando: false,
            ventanaComercialCargada: [],
            sectores: [],
            partidas: [],
            ventanaComercialData: [
                { value: 'Enero', label: 'Enero' },
                { value: 'Febrero', label: 'Febrero' },
                { value: 'Marzo', label: 'Marzo' },
                { value: 'Abril', label: 'Abril' },
                { value: 'Mayo', label: 'Mayo' },
                { value: 'Junio', label: 'Junio' },
                { value: 'Julio', label: 'Julio' },
                { value: 'Agosto', label: 'Agosto' },
                { value: 'Septiembre', label: 'Septiembre' },
                { value: 'Octubre', label: 'Octubre' },
                { value: 'Noviembre', label: 'Noviembre' },
                { value: 'Diciembre', label: 'Diciembre' }
            ],
            response:   [], 
            loadData:   true,
            sectorCargado: "0",
            agregarPartidas: false,
            partidaSeleccionada: '0',
            miniaturaImagenProducto: "",
            miniaturaImagenSEO: "",
            sDescripcion: EditorState.createEmpty(),
            sDescripcionHTML : '',
            presentacion: EditorState.createEmpty(),
            presentacionHTML : '',
            origen: EditorState.createEmpty(),
            origenHTML : '',
            especie: EditorState.createEmpty(),
            especieHTML : '',
            zonaProduccion: EditorState.createEmpty(),
            zonaProduccionHTML : '',
            normas: EditorState.createEmpty(),
            normasHTML : '',
            usoAplicaciones: EditorState.createEmpty(),
            usoAplicacionesHTML : ''
            // slugProducto: ''
        }
        this.handleChange       = this.handleChange.bind(this);
        this.handleInputChange  = this.handleInputChange.bind(this);
        this.onEditorChange     = this.onEditorChange.bind(this);
    }

    /*
    sDescripcionChange = (event) => {
        let html = stateToHTML(this.state.sDescripcion.getCurrentContent());
        this.setState({sDescripcion: event, sDescripcionHTML: html });
        let copyFichaProducto = JSON.parse(JSON.stringify(this.state.fichaProducto));
        copyFichaProducto["sDescripcion"] = html;
        this.setState({
            fichaProducto: copyFichaProducto
        });
    };

    presentacionChange = (event) => {
        let html = stateToHTML(this.state.presentacion.getCurrentContent());
        this.setState({presentacion: event, presentacionHTML: html });
        let copyFichaProducto = JSON.parse(JSON.stringify(this.state.fichaProducto));
        copyFichaProducto["presentacion"] = html;
        this.setState({
            fichaProducto: copyFichaProducto
        });
    };

    origenChange = (event) => {
        let html = stateToHTML(this.state.origen.getCurrentContent());
        this.setState({origen: event, origenHTML: html });
        let copyFichaProducto = JSON.parse(JSON.stringify(this.state.fichaProducto));
        copyFichaProducto["origen"] = html;
        this.setState({
            fichaProducto: copyFichaProducto
        });
    };

    especieChange = (event) => {
        let html = stateToHTML(this.state.especie.getCurrentContent());
        this.setState({especie: event, especieHTML: html });
        let copyFichaProducto = JSON.parse(JSON.stringify(this.state.fichaProducto));
        copyFichaProducto["especie"] = html;
        this.setState({
            fichaProducto: copyFichaProducto
        });
    };

    zonaProduccionChange = (event) => {
        let html = stateToHTML(this.state.zonaProduccion.getCurrentContent());
        this.setState({zonaProduccion: event, zonaProduccionHTML: html });
        let copyFichaProducto = JSON.parse(JSON.stringify(this.state.fichaProducto));
        copyFichaProducto["zonaProduccion"] = html;
        this.setState({
            fichaProducto: copyFichaProducto
        });
    };

    normasChange = (event) => {
        let html = stateToHTML(this.state.normas.getCurrentContent());
        this.setState({normas: event, normasHTML: html });
        let copyFichaProducto = JSON.parse(JSON.stringify(this.state.fichaProducto));
        copyFichaProducto["normas"] = html;
        this.setState({
            fichaProducto: copyFichaProducto
        });
    };

    usoAplicacionesChange = (event) => {
        let html = stateToHTML(this.state.usoAplicaciones.getCurrentContent());
        this.setState({usoAplicaciones: event, usoAplicacionesHTML: html });
        let copyFichaProducto = JSON.parse(JSON.stringify(this.state.fichaProducto));
        copyFichaProducto["usoAplicaciones"] = html;
        this.setState({
            fichaProducto: copyFichaProducto
        });
    };
    */

    deleteCache = (slug, productoCodigo) => {
        const baseUrl   = getFrontPageUrl();
        const urldeleteCache = `${baseUrl}/cache/limpiar-ficha-producto?slug=${slug}&productoCodigo=${productoCodigo}`;
        axios.delete(
            urldeleteCache, 
            cacheConfig
        ).then((res) => {

            console.log(res.data);
            console.log(res.data.message);

        }).catch((err) => {
            console.error(err);
        });
    }

    handleClickGuardar(e) {
        e.preventDefault();

        if(this.state.guardando == false){
            this.setState({ guardando: true });
            const me = this;
    
            const url = `${API_URL}FichaProductoUX/Actualizar`;
            
            let fichaProducto = {...this.state.fichaProducto};
            
            setDataForm(fichaProducto);
            
            fichaProducto["nSectorCodigo"] = document.getElementById('sectorCodigo').value;
            fichaProducto["usuarioCreacion"] = cookie.load('user').nUsuCodigo;
            fichaProducto['estado'] = Number(fichaProducto['estado']); 

            let newState = this.state;
            let hasError = false;
            
            if (!fichaProducto.nombreProducto || fichaProducto.nombreProducto == '') {
                newState.Validacion.nombreProducto.Error = true;
                toast.error(newState.Validacion.nombreProducto.RequeridoError);
                hasError = true;
            }
            
            if (!fichaProducto.fpro_Slug || fichaProducto.fpro_Slug == '') {
                newState.Validacion.fpro_Slug.Error = true;
                toast.error(newState.Validacion.fpro_Slug.RequeridoError);
                hasError = true;
            }
            
            if (!fichaProducto.nombreComercial || fichaProducto.nombreComercial == '') {
                newState.Validacion.nombreComercial.Error = true;
                toast.error(newState.Validacion.nombreComercial.RequeridoError);
                hasError = true;
            }
            
            if (!fichaProducto.nSectorCodigo || fichaProducto.nSectorCodigo == 0) {
                newState.Validacion.nSectorCodigo.Error = true;
                toast.error(newState.Validacion.nSectorCodigo.RequeridoError);
                hasError = true;
            }
            
            if (!fichaProducto.imagenProducto || fichaProducto.imagenProducto == '') {
                newState.Validacion.imagenProducto.Error = true;
                toast.error(newState.Validacion.imagenProducto.RequeridoError);
                hasError = true;
            }
            
            if(hasError){
                this.setState(newState);
                return;
            }

            console.log(fichaProducto);

            const slug              = fichaProducto.fpro_Slug;
		    const productoCodigo    = fichaProducto.productoCodigo;
            this.deleteCache(slug, productoCodigo);

            axios.post(url, JSON.stringify(JSON.stringify(fichaProducto)),
            { 
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8' ,
                    'Accept': 'application/json'
                }
            }).then((data)=> {
                me.setState({ guardando:false });
                
                if (data.data.result)
                if(data.data.result.status){
                    this.deleteCache(slug, productoCodigo);
                    this.props.history.push({
                        pathname: '/ficha-producto'
                    });
                }else{
                    toast.error(data.data.result.error);
                }
            }).catch((error)=> {
                toast.error('Error no controlado.');
                me.setState({ guardando:false });
            });
        }
    }

    handleChange(e) {
        this.setState({ sectorCargado: e.target.value });
    }

    chargeVentanaComercial(value){
        var resultado = []
        if (value != null){
            var valores = value.split(",");
            this.state.ventanaComercialData.forEach((ventana) => {
                valores.forEach((valor) => {
                    if(ventana.value == valor)
                        resultado.push(ventana)
                })
            })
            return resultado
        }
        else{
            return resultado
        }
    }

    handleClickCancel(e) {
        this.props.history.push({
            pathname: '/ficha-producto'
        });
    }

    showModalFile = (clase = "") => {
        showModalPageClass(clase);
    }

    getSectors(){
        axios.get(API_URL + 'SectorUX').then(response => response.data)
        .then((data) => {
            let sectores = [];

            data.result.forEach(option => {
                if(option.bActivo === true){
                    sectores.push({id: option.nSectorCodigo, nombre: option.sDescripcion});
                }
            });

            this.setState({
                sectores: sectores
            });
        });
    }

    onSelectArchivo(fileName, fileData, fieldName, fieldNameData){
        let fichaProducto = {... this.state.fichaProducto};

        fichaProducto[fieldName] = fileName;
        fichaProducto[fieldNameData] = fileData;
        
        document.getElementById(fieldName).value = fileName;

        this.setState({
            fichaProducto
        });

        if(fieldName == 'imagenProducto'){
            let validaciones = this.state.Validacion;
            validaciones[fieldName].Error = false;
            this.setState({
                Validacion: validaciones,
                miniaturaImagenProducto: fileData
            });
        }
        
        if(fieldName == 'imagenSEO'){
            this.setState({
                miniaturaImagenSEO: fileData
            });
        }

        hideModalPageClass(`div${fieldName}Upload`);
    }

    checkedValidate = (item) => {
        let fichaProducto = this.state.fichaProducto;
        fichaProducto[item] = !fichaProducto[item];

        this.setState({
            fichaProducto: fichaProducto
        });
    }

    onTituloChange(){
        let nombreProductoVal = document.getElementById('nombreProducto').value;

        let validaciones = this.state.Validacion;
        validaciones['nombreProducto'].Error = false;
        validaciones['fpro_Slug'].Error = false;

        this.setState({
            Validacion: validaciones
        });

        document.getElementById('tituloSEO').value = nombreProductoVal;
        document.getElementById('fpro_Slug').value = generateSlugAutomatico(nombreProductoVal);
        document.getElementById('enlaceSEO').value = generateSlugAutomatico(nombreProductoVal);
        setTextInputLongitud(['fpro_Slug', 'enlaceSEO', 'tituloSEO']);
    }

    handleVentanComercial(items){
        let ventanaComercial = '';
        if(items != null && items.length > 0){
            items.forEach(item => {
                ventanaComercial = ventanaComercial + item.value + ',';
            });
    
            ventanaComercial = ventanaComercial.substring(0, ventanaComercial.length - 1);
        }

        let fichaProducto = this.state.fichaProducto;
        fichaProducto.ventanaComercial = ventanaComercial;
        this.setState({fichaProducto});
    }

    handleInputChange(event){
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        if(target.id == 'fpro_Slug' || target.id == 'nombreComercial'){
            let validaciones = this.state.Validacion;
            validaciones[target.id].Error = false;
            this.setState({
                Validacion: validaciones
            });
        }else{
            if(value) this.setState({ partidaSeleccionada: value.value });
        }
    }

    eliminarPartida(item, event){
        event.preventDefault();

        const url = `${API_URL}FichaProductoPartidaUX/Eliminar`;
        let key = this.state.key;
        const data = {
            "productoCodigo": key,
            "partidaId": item.partidaId
        }

        axios.post(url, JSON.stringify(JSON.stringify(data)),
        { 
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8' ,
                    'Accept': 'application/json'
        }
        }).then((data)=> {
            if (data.data.result.status)
            {
                setTimeout(() => { 
                    this.obtenerPartidasPorId(key);
                }, 500);  
            }
        }).catch((error)=> {
            toast.error('No se ha podido eliminar esta partida. Puede que se haga referencia en otro lado.');
        });
    }

    obtenerPartidasPorId(id){
        const urlPartidas = `${API_URL}FichaProductoPartidaUX/Listar?productoCodigo=${id}`;
        axios.get(urlPartidas)
            .then(response => response.data)
            .then((data) => {
                hideLoader();
                /* console.log(data.result) */
                this.setState({ 
                    partidas: data.result.data,
                });
                /* this.ShowPaginationFive(0); */
            })
            .catch(error => {
                hideLoader();
                toast.error('Error al listar las partidas.');
            });
    }

    guardarPartida(){
        const url = `${API_URL}FichaProductoPartidaUX/Insertar`;
        let key = this.state.key;
        const data = {
            "productoCodigo": key,
            "PartidaCodigo": this.state.partidaSeleccionada
        }
        axios.post(url, JSON.stringify(JSON.stringify(data)),
        { 
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8' ,
                    'Accept': 'application/json'
        }
        }).then((data)=> {
            if (data.data.result)
            if(data.data.result.status)
            {
                setTimeout(() => {
                    this.obtenerPartidasPorId(key);
                }, 500);  
            }else{
                toast.error(data.data.result.error);
            }
        }).catch((error)=> {
            toast.error('No se ha podido agregar esta partida.');
        });
    }

    getTitulos(){
        
        const url = `${API_URL}ParametroUX/ListarParametrosPorCodigo/FPDT`;
        axios.get(url).then((res) => {

            console.log('titulos', res.data);
            const data = res.data.result;
            this.setState({
                titulos: data
            });

        }).catch((err) => {
            console.error(err);
        });
        
    }

    componentDidMount(){
        localStorage.setItem("load", false);

        let params = this.props.match.params;
        var key = params.id;
        this.state.key = key;
        
        this.getTitulos();

        const url = `${API_URL}FichaProductoUX/ObtenerPorId?id=${key}`;
        axios.get(url)
            .then(response => response.data)
            .then((data) => {
                hideLoader();
                this.setState({ 
                    sectorCargado: data.result.data.nSectorCodigo 
                });
                this.setState({
                    ventanaComercialCargada: this.chargeVentanaComercial(data.result.data.ventanaComercial)
                });
                
                let dataficha = data.result.data;
                dataficha.Fpro_MostrarModuloEventos = dataficha.fpro_MostrarModuloEventos;
                dataficha['estado'] = Boolean(dataficha['estado'] === '1');

                this.setState({ 
                    fichaProducto: dataficha,
                    response:   data, 
                    loadData:   false,
                    miniaturaImagenProducto: data.result.data.imagenProducto ? data.result.data.imagenProducto : "",
                    miniaturaImagenSEO: data.result.data.imagenSEO ? data.result.data.imagenSEO : ""
                });
                setTimeout(() => {
                    setTextInputLongitud(['nombreProducto', 'fpro_Slug', 'nombreComercial', 'nombreCientifico',
                    'enlaceSEO', 'tituloSEO', 'descripcionSEO', 'script', 'fpro_TituloIndicador', 'celdaValor1', 'celdaTexto1', 'celdaValor2', 'celdaTexto2', 'celdaValor3', 'celdaTexto3']);
                }, 200);
                if (this.state.fichaProducto.sDescripcion != null) {
                    const blocksFromHTML = convertFromHTML(this.state.fichaProducto.sDescripcion);
                    const contentGeneralData = ContentState.createFromBlockArray(blocksFromHTML);
                    this.setState(
                        {sDescripcion: EditorState.createWithContent(contentGeneralData)});
                }
                if (this.state.fichaProducto.presentacion != null) {
                    const blocksFromHTML2 = convertFromHTML(this.state.fichaProducto.presentacion);
                    const contentGeneralData2 = ContentState.createFromBlockArray(blocksFromHTML2);
                    this.setState(
                        {presentacion: EditorState.createWithContent(contentGeneralData2)});
                }
                if (this.state.fichaProducto.origen != null) {
                    const blocksFromHTML3 = convertFromHTML(this.state.fichaProducto.origen);
                    const contentGeneralData3 = ContentState.createFromBlockArray(blocksFromHTML3);
                    this.setState(
                        {origen: EditorState.createWithContent(contentGeneralData3)});
                }
                if (this.state.fichaProducto.especie != null) {
                    const blocksFromHTML4 = convertFromHTML(this.state.fichaProducto.especie);
                    const contentGeneralData4 = ContentState.createFromBlockArray(blocksFromHTML4);
                    this.setState(
                        {especie: EditorState.createWithContent(contentGeneralData4)});
                }
                if (this.state.fichaProducto.zonaProduccion != null) {
                    const blocksFromHTML5 = convertFromHTML(this.state.fichaProducto.zonaProduccion);
                    const contentGeneralData5 = ContentState.createFromBlockArray(blocksFromHTML5);
                    this.setState(
                        {zonaProduccion: EditorState.createWithContent(contentGeneralData5)});
                }
                if (this.state.fichaProducto.normas != null) {
                    const blocksFromHTML6 = convertFromHTML(this.state.fichaProducto.normas);
                    const contentGeneralData6 = ContentState.createFromBlockArray(blocksFromHTML6);
                    this.setState(
                        {normas: EditorState.createWithContent(contentGeneralData6)});
                }
                if (this.state.fichaProducto.usoAplicaciones != null) {
                    const blocksFromHTML7 = convertFromHTML(this.state.fichaProducto.usoAplicaciones);
                    const contentGeneralData7 = ContentState.createFromBlockArray(blocksFromHTML7);
                    this.setState(
                        {usoAplicaciones: EditorState.createWithContent(contentGeneralData7)});
                }

                this.obtenerPartidasPorId(key);
                this.getSectors();
            })
            .catch(error => {
                hideLoader();
                console.log("Error al obtener el producto: ", error);
                toast.error('Error al obtener el producto');
            });

    }

    onEditorChange( editor, flag ) {
        let copyState   = this.state.fichaProducto;
        copyState[flag] = editor.editor.getData();
        //console.log(copyState);
        this.setState({
            fichaProducto: copyState
        });
    }

    render() {
        const { 
            sDescripcion, 
            especie, 
            origen, 
            presentacion, 
            zonaProduccion, 
            normas, 
            usoAplicaciones 
        } = this.state.fichaProducto;

        const {titulos} = this.state;

        console.log(this.state.fichaProducto);

        return (
            (this.state.response.statusCode === 200 && !this.state.loadData)?
            <div className="">
                <div className="divContenedorBreadcrumbs">
                    <div className="divCenterBreadcrumbs">
                        <img src="/static/images/icoBreadcrumb.png" alt="icon-breadcrumb" />
                        <a href="/">
                            / Panel de configuración general
                        </a>
                        <Link to="/administradores">
                            / Administradores
                        </Link>
                        <Link to="/ficha-producto">
                            / Ficha Productos
                        </Link>
                        <span> / Editar Ficha Producto</span>
                    </div>
                </div>
                <div className="divTitulo_Panel">
                    Editar Ficha Producto
                </div>
                <div className="div_Modulos_Noticias">
                    <div className="div_WrapperEditarPagina">
                        <div className="txtFile x-1">
                            <input type="text" placeholder="Nombre" id='nombreProducto'  maxLength={255} onChange={() => this.onTituloChange()} defaultValue={this.state.fichaProducto.nombreProducto} className={`data-test data-form ${this.state.Validacion.nombreProducto.Error ? "error" : ""}`}/>
                            <span id="longitudnombreProducto"></span>
                        </div>
                        <div className="txtFile x-1">
                            <input type="text" placeholder="Slug" id='fpro_Slug'  maxLength={255} className={`data-test data-form ${this.state.Validacion.fpro_Slug.Error ? "error" : ""}`}
                            onChange={this.handleInputChange} defaultValue={this.state.fichaProducto.fpro_Slug}/>
                            <span id="longitudfpro_Slug"></span>
                        </div>
                        <div className="txtFile x-1">
                            <input type="text" placeholder="Nombre Comercial" id='nombreComercial' maxLength={100} className={`data-test data-form ${this.state.Validacion.nombreComercial.Error ? "error" : ""}`}
                            onChange={this.handleInputChange} defaultValue={this.state.fichaProducto.nombreComercial}/>
                            <span id="longitudnombreComercial"></span>
                        </div>
                        <div className="txtFile x-1">
                            <input type="text" placeholder="Nombre Científico" id='nombreCientifico' maxLength={100} className="data-test data-form" defaultValue={this.state.fichaProducto.nombreCientifico}/>
                            <span id="longitudnombreCientifico"></span>
                        </div>
                        <div className="txtFile x-1">
                            <select id='sectorCodigo' className={`data-test data-form ${this.state.Validacion.nSectorCodigo.Error ? "error" : ""}`} value={this.state.sectorCargado} onChange={this.handleChange}>
                                <option value="0">Seleccionar Sector</option>
                                {
                                    this.state.sectores.length > 0 ?
                                    this.state.sectores.map((sector) => (
                                        <option key={sector.id} value={sector.id}>{sector.nombre.toUpperCase()}</option>
                                            
                                    ))
                                    : null
                                }
                            </select>  
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="boletin__filters section__margin-bottom">
                                {titulos.length > 0 ? generateLabel(titulos.find(item => item.indice === 'DETALLE_PRODUCTO_DESCRIPCION').valor) : ""}
                                    <CKEditor
                                        data={sDescripcion ? sDescripcion : ""}
                                        onChange={(editor) => this.onEditorChange(editor, 'sDescripcion')}
                                        config={ckeditorconfig}
                                        placeholder="Ingrese Descripción..."
                                    />
                                    {/*
                                    <Editor
                                        placeholder="Ingrese Descripción..."
                                        id="sDescripcion"
                                        name="sDescripcion"
                                        editorState={sDescripcion}
                                        wrapperClassName="demo-wrapper"
                                        editorClassName= 'demo-editor'
                                        // height={400}
                                        onEditorStateChange={this.sDescripcionChange}
                                    />
                                    */}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="boletin__filters section__margin-bottom">
                                {titulos.length > 0 ? generateLabel(titulos.find(item => item.indice === 'DETALLE_PRODUCTO_PRESENTACIONES').valor) : ""}
                                    <CKEditor
                                        data={presentacion ? presentacion : ""}
                                        onChange={(editor) => this.onEditorChange(editor, 'presentacion')}
                                        config={ckeditorconfig}
                                        placeholder="Ingrese Presentación..."
                                    />
                                    {/* 
                                    <Editor
                                        placeholder="Ingrese Presentación..."
                                        id="presentacion"
                                        name="presentacion"
                                        editorState={presentacion}
                                        wrapperClassName="demo-wrapper"
                                        editorClassName= 'demo-editor'
                                        // height={400}
                                        onEditorStateChange={this.presentacionChange}
                                    />
                                    */}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="boletin__filters section__margin-bottom">
                                    {titulos.length > 0 ? generateLabel(titulos.find(item => item.indice === 'DETALLE_PRODUCTO_ESPECIES').valor) : ""}
                                    <CKEditor
                                        data={especie ? especie : ""}
                                        onChange={(editor) => this.onEditorChange(editor, 'especie')}
                                        config={ckeditorconfig}
                                        placeholder="Ingrese Especies / Variedades..."
                                    />
                                    {/* 
                                    <Editor
                                        placeholder="Ingrese Especies / Variedades..."
                                        id="especie"
                                        name="especie"
                                        editorState={especie}
                                        wrapperClassName="demo-wrapper"
                                        editorClassName= 'demo-editor'
                                        // height={400}
                                        onEditorStateChange={this.especieChange}
                                    />
                                    */}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="boletin__filters section__margin-bottom">
                                {titulos.length > 0 ? generateLabel(titulos.find(item => item.indice === 'DETALLE_PRODUCTO_PRODUCCION').valor) : ""}
                                    <CKEditor
                                        data={zonaProduccion ? zonaProduccion : ""}
                                        onChange={(editor) => this.onEditorChange(editor, 'zonaProduccion')}
                                        config={ckeditorconfig}
                                        placeholder="Ingrese Zona de Producción..."
                                    />
                                    {/* 
                                    <Editor
                                        placeholder="Ingrese Zona de Producción..."
                                        id="zonaProduccion"
                                        name="zonaProduccion"
                                        editorState={zonaProduccion}
                                        wrapperClassName="demo-wrapper"
                                        editorClassName= 'demo-editor'
                                        // height={400}
                                        onEditorStateChange={this.zonaProduccionChange}
                                    />
                                    */}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="boletin__filters section__margin-bottom">
                                {titulos.length > 0 ? generateLabel(titulos.find(item => item.indice === 'DETALLE_PRODUCTO_ORIGEN').valor) : ""}
                                    <CKEditor
                                        data={origen ? origen : ""}
                                        onChange={(editor) => this.onEditorChange(editor, 'origen')}
                                        config={ckeditorconfig}
                                        placeholder="Ingrese Origen..."
                                    />
                                    {/* 
                                    <Editor
                                        placeholder="Ingrese Origen..."
                                        id="origen"
                                        name="origen"
                                        editorState={origen}
                                        wrapperClassName="demo-wrapper"
                                        editorClassName= 'demo-editor'
                                        // height={400}
                                        onEditorStateChange={this.origenChange}
                                    />
                                    */}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="boletin__filters section__margin-bottom">
                                {titulos.length > 0 ? generateLabel(titulos.find(item => item.indice === 'DETALLE_PRODUCTO_USOS').valor) : ""}
                                    <CKEditor
                                        data={usoAplicaciones ? usoAplicaciones : "Ingrese Uso y Aplicaciones..."}
                                        onChange={(editor) => this.onEditorChange(editor, 'usoAplicaciones')}
                                        config={ckeditorconfig}
                                        placeholder="Ingrese Uso y Aplicaciones..."
                                    />
                                    {/* 
                                    <Editor
                                        placeholder="Ingrese Uso y Aplicaciones..."
                                        id="usoAplicaciones"
                                        name="usoAplicaciones"
                                        editorState={usoAplicaciones}
                                        wrapperClassName="demo-wrapper"
                                        editorClassName= 'demo-editor'
                                        // height={400}
                                        onEditorStateChange={this.usoAplicacionesChange}
                                    />
                                    */}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="boletin__filters section__margin-bottom">
                                {titulos.length > 0 ? generateLabel(titulos.find(item => item.indice === 'DETALLE_PRODUCTO_NORMAS').valor) : ""}
                                    <CKEditor
                                        data={normas ? normas : "Ingrese Normas de Calidad..."}
                                        onChange={(editor) => this.onEditorChange(editor, 'normas')}
                                        config={ckeditorconfig}
                                        placeholder="Ingrese Normas de Calidad..."
                                    />
                                    {/*
                                    <Editor
                                        placeholder="Ingrese Normas de Calidad..."
                                        id="normas"
                                        name="normas"
                                        editorState={normas}
                                        wrapperClassName="demo-wrapper"
                                        editorClassName= 'demo-editor'
                                        // height={400}
                                        onEditorStateChange={this.normasChange}
                                    />
                                    */}
                                </div>
                            </div>
                        </div>
                        <div className="divWrapperActive">
                            <div>
                                <span>Habilitado</span>
                            </div>
                            <div>
                                <div className={this.state.fichaProducto.estado ? "containerActive backgroundPosition" : "containerActive"} onClick={() => this.checkedValidate("estado")}>
                                    <div className={this.state.fichaProducto.estado ? "actionActive leftPosition" : "actionActive"}/>
                                </div>
                                <span>{this.state.fichaProducto.estado ? "Activado" : "Desactivado"}</span>
                            </div>
                            
                            <div>
                                <span>Incluir Modulo Eventos</span>
                            </div>
                            <div>
                                <div 
                                    className={this.state.fichaProducto.Fpro_MostrarModuloEventos ? "containerActive backgroundPosition" : "containerActive"} 
                                    onClick={() => this.checkedValidate("Fpro_MostrarModuloEventos")}
                                >
                                    <div className={this.state.fichaProducto.Fpro_MostrarModuloEventos ? "actionActive leftPosition" : "actionActive"}/>
                                </div>
                                <span>
                                    {this.state.fichaProducto.Fpro_MostrarModuloEventos ? "Activado" : "Desactivado"}
                                </span>
                            </div>
                           
                        </div>
                        <div className="x-2 relative">
                            <span className="subirArchivo" onClick={() => this.showModalFile("divArchivoUpload")}/>
                            <input type="text" placeholder="Archivo" id="archivo" defaultValue={this.state.fichaProducto.archivo} className="data-test data-form"/>
                            <i className="info">* El archivo debe tener formato de documento</i>
                            <br />
                        </div>
                        <div className="x-2 relative">
                            <span className="subirImagen" onClick={() => this.showModalFile("divImagenProductoUpload")}/>
                            <input type="text" placeholder="Imagen del producto" id="imagenProducto" defaultValue={this.state.fichaProducto.imagenProducto}
                             className={`data-test data-form ${this.state.Validacion.imagenProducto.Error} ? "error" : ""`} />
                            <br />
                        </div>
                        <div className='row w-100 justify-content-end'>
                            <div className="col-md-6 p-2 text-center">
                                <div className="section__margin-bottom">
                                    {!this.state.miniaturaImagenProducto
                                        ? (
                                        <div>
                                            <p>No se ha seleccionado ninguna imagen.</p>
                                        </div>)
                                        : (
                                        <div>
                                            <img className="col-md-6"
                                            src={(this.state.miniaturaImagenProducto.startsWith('http') || this.state.miniaturaImagenProducto.startsWith('data:image')) ? this.state.miniaturaImagenProducto :  (BASE_URL_PRODUCTOS + this.state.miniaturaImagenProducto)} />
                                            <br/><br/>  
                                        </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="txtFile x-1">
                            <input type="text" placeholder="Título Indicador" id='fpro_TituloIndicador' maxLength={500} defaultValue={this.state.fichaProducto.fpro_TituloIndicador} className="data-test data-form"/>
                            <span id="longitudfpro_TituloIndicador"></span>
                        </div>
                        <div className="txtFile x-2 relative">
                            <input type="text" placeholder="Cuadro 1 Valor" id='celdaValor1' maxLength={255} defaultValue={this.state.fichaProducto.celdaValor1} className="data-test data-form"/>
                            <span id="longitudceldaValor1"></span>
                        </div>
                        <div className="txtFile x-2 relative">
                            <input type="text" placeholder="Cuadro 1 Descripción" id='celdaTexto1' maxLength={255} defaultValue={this.state.fichaProducto.celdaTexto1} className="data-test data-form"/>
                            <span id="longitudceldaTexto1"></span>
                        </div>
                        <div className="txtFile x-2 relative">
                            <input type="text" placeholder="Cuadro 2 Valor" id='celdaValor2' maxLength={255} defaultValue={this.state.fichaProducto.celdaValor2} className="data-test data-form"/>
                            <span id="longitudceldaValor2"></span>
                        </div>
                        <div className="txtFile x-2 relative">
                            <input type="text" placeholder="Cuadro 2 Descripción" id='celdaTexto2' maxLength={255} defaultValue={this.state.fichaProducto.celdaTexto2} className="data-test data-form"/>
                            <span id="longitudceldaTexto2"></span>
                        </div>
                        <div className="txtFile x-2 relative">
                            <input type="text" placeholder="Cuadro 3 Valor" id='celdaValor3' maxLength={255} defaultValue={this.state.fichaProducto.celdaValor3} className="data-test data-form"/>
                            <span id="longitudceldaValor3"></span>
                        </div>
                        <div className="txtFile x-2 relative">
                            <input type="text" placeholder="Cuadro 3 Descripción" id='celdaTexto3' maxLength={255} defaultValue={this.state.fichaProducto.celdaTexto3} className="data-test data-form"/>
                            <span id="longitudceldaTexto3"></span>
                        </div>
                        <div className="txtFile x-1">
                            <Select
                                classNamePrefix="data-test data-form select"
                                placeholder="Ventana Comercial"
                                options={this.state.ventanaComercialData}
                                onChange={items => this.handleVentanComercial(items)}
                                defaultValue={ this.state.ventanaComercialCargada || 'Select'}
                                isMulti={true}
                                isSearchable={true} />
                        </div>
                    </div>

                    <div className="clear"></div>

                    <div className="divModulo_Seo">
                        <h2>Partidas Relacionadas</h2>
                        <div className="divWrapperModulo_Seo">
                            {
                                        !this.state.agregarPartidas ? 
                                (
                                    <button className='btn btn-success'
                                    type="button"
                                    onClick={() => this.setState({ agregarPartidas:true }) }
                                    >
                                        Agregar Partida
                                    </button>
                                )
                                :
                                (
                                    <div style={{ 'width': '100%', 'padding': 15 }}>
                                        <div>
                                        <DropDownList
                                            valor={this.state.partidaSeleccionada}
                                            clave={this.state.partidaSeleccionada}
                                            name="partidas" 
                                            id="partidas-dropdown" 
                                            onChange={this.handleInputChange}
                                            componente={"PartidaCodigo"} 
                                        />
                                        </div>
                                        <button className='btn btn-success' style={{ 'margin': 15 }}
                                        onClick={() => this.guardarPartida() }>Agregar</button>
                                    </div>
                                    
                                
                                )
                            }
                            <div className="divTablaPage_Panel">
                                <table border={1} cellSpacing={0}>
                                    <tbody>
                                        <tr>
                                            <th>N°</th>
                                            <th>Partida</th>
                                            <th>Descripcion</th>
                                            <th>Acción</th>
                                        </tr>
                                            {
                                                this.state.partidas && this.state.partidas.length > 0 ? 
                                                this.state.partidas.map((item, index) => (
                                                    <tr key={`partida-codigo-${item.partidaId}`}>
                                                        <td>{index + 1}</td>
                                                        <td>{item.partidaCodigo}</td>
                                                        <td>{item.partidaDescripcion}</td>
                                                        <td>
                                                            <div className="divBtnAcciones" style={{ 'width': 100, 'justifyContent': 'center' }}>
                                                                
                                                                <a href="#" className="btnPageModuloEliminar aEliminarMenu2"/>
                                                                <div className="c_divAlertaCapa">
                                                                    <div className="divAlertaCapa">
                                                                        <div className="divAlerta">
                                                                            <h2>&iquest;Seguro de eliminar?</h2>
                                                                            <div className="divAlertaBtn">
                                                                                <a href="#" className="btnAlertaAceptar" onClick={(event) => this.eliminarPartida(item, event)}>ACEPTAR</a>
                                                                                <a href="#" className="btnAlertaCancelar">CANCELAR</a>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))

                                                :

                                                (
                                                    <tr>
                                                        <td colSpan="5" className="tdSinResultados">
                                                            No se encontraron partidas relacionadas.
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div className="clear"></div>

                    <div className="divModulo_Seo">
                        <h2>Configuración <strong>SEO</strong></h2>
                        <div className="divWrapperModulo_Seo">
                            <div className="txtFile x-1">
                                <input type="text" placeholder="SEO Título" id='tituloSEO' defaultValue={this.state.fichaProducto.tituloSEO} maxLength="255" className="data-test data-form"/>
                                <span id="longitudtituloSEO"></span>
                            </div>
                            <div className="txtFile x-1">
                                <textarea placeholder="SEO Descripción" id='descripcionSEO' maxLength="255" style={{height:"100px"}} defaultValue={this.state.fichaProducto.descripcionSEO} className="data-test data-form"/>
                                <span id="longituddescripcionSEO"></span>
                            </div>
                            <div className="txtFile x-1 relative">
                                <span className="subirImagen" onClick={() => this.showModalFile("divImagenSEOUpload")} />
                                <input type="text" placeholder="SEO Imagen" id='imagenSEO' defaultValue={this.state.fichaProducto.imagenSEO} className="data-test data-form"/>
                            </div>
                            <div className="col-md-6 p-2 text-center">
                                <div className="section__margin-bottom">
                                    {!this.state.miniaturaImagenSEO
                                        ? (
                                        <div>
                                            <p>No se ha seleccionado ninguna imagen.</p>
                                        </div>)
                                        : (
                                        <div>
                                            <img className="col-md-6"
                                            src={(this.state.miniaturaImagenSEO.startsWith('http') || this.state.miniaturaImagenSEO.startsWith('data:image')) ? this.state.miniaturaImagenSEO : (BASE_URL_PRODUCTOS + this.state.miniaturaImagenSEO)} />
                                            <br/><br/>  
                                        </div>
                                        )
                                    }
                                </div>
                            </div>
                            <div className="txtFile x-1">
                                <input type="text" placeholder="Enlace" id='enlaceSEO' maxLength="255" defaultValue={this.state.fichaProducto.enlaceSEO} className="data-test data-form"/>
                                <span id="longitudenlaceSEO"></span>
                            </div>
                            <div className="divWrapperActive">
                                <div>
                                    <span>Motores de busqueda <br />seguir enlaces</span>
                                </div>
                                <div>
                                    <div className={this.state.fichaProducto.seguirBuscadoresSEO ? "containerActive backgroundPosition" : "containerActive"} onClick={() => this.checkedValidate("seguirBuscadoresSEO")}>
                                        <div className={this.state.fichaProducto.seguirBuscadoresSEO ? "actionActive leftPosition" : "actionActive"}/>
                                    </div>
                                    <span>{this.state.fichaProducto.seguirBuscadoresSEO ? "Activado" : "Desactivado"}</span>
                                </div>
                                <div>
                                    <span>Mostrar Pagina <br />Motores de Búsqueda </span>
                                </div>
                                <div>
                                    <div className={this.state.fichaProducto.mostrarBuscadoresSEO ? "containerActive backgroundPosition" : "containerActive"} onClick={() => this.checkedValidate("mostrarBuscadoresSEO")}>
                                        <div className={this.state.fichaProducto.mostrarBuscadoresSEO ? "actionActive leftPosition" : "actionActive"}/>
                                    </div>
                                    <span>{this.state.fichaProducto.mostrarBuscadoresSEO ? "Activado" : "Desactivado"}</span>
                                </div>
                            </div>
                            <div className="txtFile x-1">
                                <textarea placeholder="Pegue aquí su código JavaScript" id="script" style={{height:"100px"}} maxLength="32000" defaultValue={this.state.fichaProducto.script} className="data-test data-form"/>
                                <span id="longitudscript"></span>
                            </div>
                        </div>
                    </div>

                    <div className="divContenedorBtn_Noticias">
                        {/* <a href="#" className="btnActivo" onClick={(event) => this.prueba(event)}>{this.state.guardando ? 'PROCESANDO...' : 'GUARDAR'}</a> */}
                        <a href="#" className="btnActivo" onClick={(event) => this.handleClickGuardar(event)}>{this.state.guardando ? 'PROCESANDO...' : 'GUARDAR'}</a>
                        <a href="#" onClick={(event) => this.handleClickCancel(event)}>VOLVER</a>
                    </div>
                </div>
                <ModalFile class={"divArchivoUpload"} onSelect={(filename, data) => this.onSelectArchivo(filename, data, "archivo", "archivoData")} tipo="doc"/>
                <ModalFile class={"divImagenProductoUpload"} onSelect={(filename, data) => this.onSelectArchivo(filename, data, "imagenProducto", "imagenProductoData")} tipo="image"
                    helpText="La imagen debe tener una relacion de aspecto recomendada de: 13:9 Por ejemplo: 520 × 360 px"/>
                <ModalFile class={"divImagenSEOUpload"} onSelect={(filename, data) => this.onSelectArchivo(filename, data, "imagenSEO", "imagenSEOData")} tipo="image"
                    helpText="La imagen debe tener una relacion de aspecto recomendada de: 13:9 Por ejemplo: 520 × 360 px"/>
            </div>
            :
            
            <Error StatusCode="500" StatusMessage="Error"></Error>
        )
    }
}